import { ICinemaPalette } from '../palette';

export const MOBILE = '@media (max-width: 900px)';
export const HOVER = '@media (hover: hover)';
export const REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
export const HALO = '0 1px 2px rgba(4,6,9,.55), 0 2px 22px rgba(4,6,9,.45)';
export const SOFT_HALO = '0 1px 2px rgba(4,6,9,.5)';
export const MONO = "'JetBrains Mono', monospace";
export const DISP = "'Space Grotesk', sans-serif";
export const BODY = "'Inter', sans-serif";
export const INK = '#f4f6fa';
export const INK_DIM = 'rgba(244,246,250,.72)';
export const INK_FAINT = 'rgba(244,246,250,.5)';
export const GLASS_BORDER = '1px solid rgba(255,255,255,.15)';
export const RISE = 'mytaMiniGameRise .42s cubic-bezier(.2,.7,.2,1)';

export const getSharedTokens = (palette: ICinemaPalette) => ({
  focusRing: {
    outline: `2px solid ${palette.accentHi}`,
    outlineOffset: '2px',
  },
  dot: {
    width: '7px',
    height: '7px',
    flex: 'none',
    borderRadius: '50%',
    background: palette.accentHi,
    boxShadow: `0 0 10px 2px ${palette.accentGlow}`,
  },
  kicker: {
    display: 'block',
    fontFamily: MONO,
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '.24em',
    textTransform: 'uppercase',
    color: INK_FAINT,
  },
});

export const miniGameGlobalStyles = {
  '@keyframes mytaMiniGameRise': {
    from: { opacity: 0, transform: 'translateY(14px) scale(.985)' },
    to: { opacity: 1, transform: 'none' },
  },
  '@keyframes mytaMiniGameFade': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@keyframes mytaMiniGameOrbit': {
    to: { transform: 'rotate(360deg)' },
  },
  '@keyframes mytaMiniGameChunk': {
    '0%, 18%': { transform: 'none', opacity: 1 },
    '62%': { transform: 'translate(-2px, 13px) rotate(-42deg)', opacity: 0 },
    '100%': { transform: 'translate(-2px, 13px) rotate(-42deg)', opacity: 0 },
  },
  '@keyframes mytaMiniGameBlade': {
    '0%': { transform: 'translate(0, 0)', opacity: 0 },
    '12%': { opacity: 1 },
    '58%': { transform: 'translate(31.2px, 18px)', opacity: 1 },
    '70%, 100%': { transform: 'translate(31.2px, 18px)', opacity: 0 },
  },
  '@keyframes mytaMiniGameDots': {
    '0%, 80%, 100%': { opacity: 0.25, transform: 'scale(.7)' },
    '40%': { opacity: 1, transform: 'scale(1)' },
  },
};
